<rs-web-success-screen>
  <h2 class="title">{{ 'ticket_creation.success.title_l' | translate }}</h2>
  <p class="primary-text">{{ 'user_edit_success_desc_1' | translate }}</p>

  <p class="fw-bold primary-text">
    {{ 'user_edit_success_desc_2' | translate }}
  </p>
</rs-web-success-screen>
